import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import Image from '@segment/matcha/components/Image'
import Typography from '@segment/matcha/components/Typography'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import dashboardExplorePng2x from './assets/DashboardExplore@2x.png'
import dashboardExploreWebp from './assets/DashboardExplore.webp'
import dashboardExploreWebp2x from './assets/DashboardExplore@2x.webp'
import dashboardUnderstandPng2x from './assets/DashboardUnderstand@2x.png'
import dashboardUnderstandWebp from './assets/DashboardUnderstand.webp'
import dashboardUnderstandWebp2x from './assets/DashboardUnderstand@2x.webp'

const DashboardExploreImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${dashboardExploreWebp}, ${dashboardExploreWebp2x} 2x`} />
      <Image width="536" height="340" src={dashboardExplorePng2x} alt="Dashboard Explore image" loading="lazy" />
    </Picture>
  )
}

const DashboardUnderstandImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${dashboardUnderstandWebp}, ${dashboardUnderstandWebp2x} 2x`} />
      <Image width="536" height="340" src={dashboardUnderstandPng2x} alt="Dashboard Understand image" loading="lazy" />
    </Picture>
  )
}

const copy = {
  title: `Trust in our predictions with model transparency`,
  description: `CustomerAI Predictions provides transparency into every prediction you create, so your marketing and data teams always feel confident in your predictions.`,
  columns: [
    {
      image: <DashboardExploreImage />,
      title: (
        <CopyTextBase>
          <CopyText.Description variant="pLarge">
            <Typography tag="b" variant="pLargeBold">
              The Explore view
            </Typography>
            {` `}
            visualizes the prediction data and lets marketers easily cohort that data to create audiences for targeted
            campaigns or customer journeys.
          </CopyText.Description>
        </CopyTextBase>
      ),
    },
    {
      image: <DashboardUnderstandImage />,
      title: (
        <CopyTextBase>
          <CopyText.Description variant="pLarge">
            <Typography tag="b" variant="pLargeBold">
              The Understanding view
            </Typography>
            {` `}
            offers insights into all the underlying data points and how they contribute to the model.
          </CopyText.Description>
        </CopyTextBase>
      ),
    },
  ],
}

const TrustIn = () => {
  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.title}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack
          columns={1}
          overrides={{
            md: 2,
          }}
        >
          {copy.columns.map(({ image, title }, key) => (
            <Wrapper key={key}>
              {image}
              <CopyTextWrapper>{title}</CopyTextWrapper>
            </Wrapper>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const CopyTextWrapper = styled.div`
  margin-top: 32px;
`

const Wrapper = styled.div``

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 1120px;
  margin: 0 auto;
`

export default TrustIn
